import React, { useState, useEffect, useRef } from 'react'
import {
  Button,
  Input, Tree, message, Modal,
  Divider,
} from 'antd'
import { searchOtherWords, delOtherWords, addOtherWords, editOtherWords } from '../../../../api/inspiration';
import './index.less'

export default () => {
  const [word, setWord] = useState('')
  const [chooseItem, setChooseItem] = useState({ key: null, title: '', translationWord: '' });
  const [delModalVisible, setDelModalVisible] = useState(false);
  const [addModalVisible, setAddModalVisible] = useState(false);
  const [editModalVisible, setEditModalVisible] = useState(false);
  const [selectedKeys, setSelectedKeys] = useState([]);
  const [treeData, setTreeData] = useState([])
  const [addParam, setAddParam] = useState({
    supplementWord: '', translationWord: ''
  });
  const init = () => {
    onSearch()
    setTreeData([])
    setSelectedKeys([])
    setChooseItem({ key: null, title: '', translationWord: '' })
  }
  const handleInputChange = (e) => {
    setWord(e.target.value)
  }
  const onSearch = () => {
    goSearchOtherWords()
  }
  const clearAll = () => {
    setWord('')
  }
  const onDel = () => {
    setDelModalVisible(true)
  }
  const onAdd = () => {
    setAddModalVisible(true)
  }
  const onDetail = () => {
    setEditModalVisible(true)
    setAddParam({ supplementWord: chooseItem?.title, translationWord: chooseItem?.translationWord })
  }
  const onSelect = (selectedKeys, info) => {
    setSelectedKeys(selectedKeys)
    setChooseItem(info?.node?.props)
  };

  const goSearchOtherWords = async () => {
    const res = await searchOtherWords(word)
    if (res?.error?.code == 0) {
      let arr = res?.data?.supplementTags.map((item) => {
        return { ...item, key: item.id, title: item.nodeWord }
      })
      setTreeData(arr)
    }
  }
  const goDelOtherWords = async () => {
    const res = await delOtherWords(chooseItem?.title)
    if (res?.error?.code == 0) {
      message.success('删除成功')
      setDelModalVisible(false)
      init()
    }
  }
  const goAddOtherWords = async () => {
    const res = await addOtherWords(addParam)
    if (res?.error?.code == 0) {
      message.success('提交成功')
      setAddParam({
        supplementWord: '', translationWord: ''
      })
      setAddModalVisible(false)
      init()
    } else {
      message.error('提交失败')
    }
  }
  const goEditOtherWords = async () => {
    const res = await editOtherWords({ id: chooseItem?.key, newNodeWord: addParam?.supplementWord, newTranslationWord: addParam?.translationWord, oldNodeWord: chooseItem?.title, oldTranslationWord: chooseItem?.translationWord })
    if (res?.error?.code == 0) {
      message.success('修改成功')
      setAddParam({
        supplementWord: '', translationWord: ''
      })
      setEditModalVisible(false)
      init()
    } else {
      message.error('修改失败')
    }
  }
  const handleDelModalOk = () => {
    if (!chooseItem?.title) {
      message.info('未选择补充标签哦')
      return
    }
    goDelOtherWords()
  }
  const handleAddModalOk = () => {
    addModalVisible ? goAddOtherWords() : goEditOtherWords()
  }
  return (
    <div className='otherWordsManager'>
      <div className='otherWordsManagerHeader'>本体库&gt;补充标签管理</div>
      <div className='otherWordsManagerOperation'>
        <div className='top-recommend-searchArea'>
          <Input
            style={{ width: 200 }}
            value={word}
            onChange={handleInputChange}
            onPressEnter={onSearch}
          />
        </div>
        <div style={{ display: 'inline-block', width: 80 }}>
          <Button type='primary' onClick={clearAll}>重置</Button>
        </div>
        <div style={{ display: 'inline-block', width: 80 }}>
          <Button type="danger" onClick={onDel}>删除</Button>
        </div>
        <div style={{ display: 'inline-block', width: 80 }}>
          <Button type="primary" onClick={onAdd}>新增</Button>
        </div>
        <div style={{ display: 'inline-block', width: 100 }}>
          <Button type="primary" onClick={onDetail}>查看详情</Button>
        </div>
        <Divider />
      </div>
      <div className="otherWordsContainer">
        <Tree
          multiple={false}
          checkStrictly={true}
          onSelect={onSelect}
          selectedKeys={selectedKeys}
          treeData={treeData}
        />
      </div>
      <Modal title="删除" visible={delModalVisible} onOk={handleDelModalOk} okText='确定' cancelText='取消' onCancel={() => setDelModalVisible(false)}>
        <p>您要删除的补充标签是：{chooseItem?.title}</p>
      </Modal>
      <Modal title={addModalVisible ? '新增补充标签' : '查看详情'} visible={addModalVisible || editModalVisible} footer={false} onCancel={() => {
        setAddModalVisible(false)
        setEditModalVisible(false)
        setAddParam({
          supplementWord: '', translationWord: ''
        })
      }}>
        <div>
          <label>补充标签名称*：</label>
          <Input placeholder="补充标签名称(必填)" value={addParam.supplementWord} onChange={(e) => {
            setAddParam({
              ...addParam,
              supplementWord: e.target.value
            })
          }} />
        </div>
        <div>
          <label>翻译词：</label>
          <Input placeholder="翻译词" value={addParam.translationWord} onChange={(e) => {
            setAddParam({
              ...addParam,
              translationWord: e.target.value
            })
          }} />
        </div>
        <div style={{ marginTop: 20 }}>
          <Button type="primary" disabled={!addParam.supplementWord} onClick={handleAddModalOk}>
            提交
          </Button>
        </div>

      </Modal>
    </div >
  )
}